module.exports = __webpack_public_path__ + "img/news_06.a375a053.jpg";